function handleTurnstileIntersect(entries, observer) {
  const entry = entries[0];
  if (entry.isIntersecting) {
    loadTurnstile();
    observer.disconnect();
  }
}

function initLazyTurnstile() {
  const turnstileElement = document.querySelector(".cf-turnstile");
  if (!turnstileElement) {
    return;
  }

  const observer = new IntersectionObserver(handleTurnstileIntersect, {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  });
  observer.observe(turnstileElement);
}

function loadTurnstile() {
  if (document.querySelector('script[src*="turnstile/v0/api.js"]')) {
    return;
  }

  const turnstileScript = document.createElement("script");
  turnstileScript.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
  turnstileScript.defer = true;
  document.body.appendChild(turnstileScript);
}

window.addEventListener("load", initLazyTurnstile);
